import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormFeedback, InputGroup, InputGroupAddon,} from "reactstrap";
import {COUNTRY_CODE_PL} from "../utils/country";
import "flag-icons/css/flag-icons.min.css";
import useAfterUpdateEffect from "../utils/useAfterUpdateEffect";
import classnames from "classnames";
import InputMask from "react-input-mask";
import useDidMountEffect from "../utils/useDidMountEffect";
import {debounceTime, distinctUntilChanged, Subject} from "rxjs";
import {useTranslation} from "react-i18next";
import CountryCodeDropdown from "./CountryCodeDropdown";

const PhoneNumber = props => {
  const { t } = useTranslation('phone_number_input');
  const [countryCode, setCountryCode] = useState(props?.value?.countryCode);
  const [number, setNumber] = useState(props?.value?.number);
  const [number$, setNumber$] = React.useState(new Subject())

  useDidMountEffect(() => {
    number$.pipe(
      debounceTime(props.debounceTime),
      distinctUntilChanged(),
    ).subscribe(number => {
      setCountryCode(countryCode => {
        props.onChange({
          countryCode,
          number,
        })

        return countryCode
      })
    })
  })

  useAfterUpdateEffect(() => {
    setCountryCode(props.value.countryCode)
    setNumber(props.value.number)
  }, [props.value])

  useAfterUpdateEffect(() => {
    if(props.value?.countryCode !== countryCode){
      setCountryCode(props.value?.countryCode)
    }
  }, [props.value?.countryCode])

  useAfterUpdateEffect(() => {
    props.onChange({
      countryCode,
      number,
    })
  }, [countryCode])

  useAfterUpdateEffect(() => number$.next(number), [number])

  const getMask = () => {
    switch(countryCode) {
      case COUNTRY_CODE_PL: {
        return '999-999-999';
      }
      default: {
        return null
      }
    }
  }
  return (
    <InputGroup>
      <InputGroupAddon addonType={'prepend'}>
        <CountryCodeDropdown
          type={'phoneNumber'}
          countryCode={countryCode}
          onChange={setCountryCode}
        />
      </InputGroupAddon>
      <InputMask
        className={classnames({
          'form-control': true,
          'is-invalid': !!props.errorMsg,
        })}
        autoFocus={props.autoFocus}
        placeholder={t('placeholder')}
        mask={getMask()}
        onChange={e => setNumber(e.target.value.replace(/[^0-9]+/g, ''))}
        onKeyDown={e => {
          switch (e.key) {
            case 'Enter': {
              e.preventDefault()
              if(props.onAccept){
                props.onAccept()
              }
              break;
            }
          }
        }}
        value={number ?? ''}
      />
      <FormFeedback>{props.errorMsg}</FormFeedback>
    </InputGroup>
  );
};

PhoneNumber.defaultProps = {
  autoFocus: false,
  debounceTime: 0,
};

PhoneNumber.propTypes = {
  errorMsg: PropTypes.string,
  autoFocus: PropTypes.bool,
  debounceTime: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onAccept: PropTypes.func,
  value: PropTypes.shape({
    countryCode: PropTypes.string,
    number: PropTypes.string,
  }),
};

export default PhoneNumber;